import React, {useEffect, useState} from "react";
import useIsMounted from "../../../hooks/use-is-mounted";
import Dialog from "../../base/dialog";
import {DialogTitle, Divider} from "@mui/material";
import ConfigureCustomerBypassLimitsSection from "./sections/configure-customer-bypass-limits";
import UpsertBypassReasonsSection from "./sections/upsert-bypass-reasons";
import SubmitBypassSection from "./sections/submit-bypass";
import Api from "../../../../core/services/api/api";


const BypassOrderDialog = ({
                               open,
                               setOpen,
                               orderNo,
                               orderId,
                               customer,
                               onBypassSuccess: onBypassSuccessProps
                           }) => {
    const [inEditMode, setInEditMode] = useState(false);
    const [loading, setLoading] = useState(false);
    const [submissionErrors, setSubmissionErrors] = useState(null);
    const [reasons, setReasons] = useState([])
    const isMounted = useIsMounted()


    /**
     * With each change in open state of the dialog:
     * - if open, then fetches the reasons for bypassing a quote
     */
    useEffect(() => {
        if (open) {
            getReasons().then();
            return;
        }
        setInEditMode(false);
    }, [open])

    /**
     * Fetches the reasons to bypass an order from the server.
     *
     * * injects custom properties to the response data for crud operations.
     */
    const getReasons = async () => {
        setLoading(true);
        const response = await Api.getQuoteBypassReasons();
        if (!isMounted()) return
        setLoading(false);
        if (response?.resultFlag) {
            setReasons(response.data?.map(e => ({
                ...e,
                editing: false,
                inEditMode: false,
                removing: false
            })) ?? [])
        }
    }

    /**
     * Closes the dialog and calls the appropriate callback if it exists.
     * @param data
     */
    const onBypassSuccess = (data) => {
        setOpen(false);
        if (onBypassSuccessProps) {
            onBypassSuccessProps(data);
        }
    }

    return (
        <>
            <Dialog
                open={open}
                setOpen={() => setOpen(false)}
                maxWidth={inEditMode ? 'md' : 'sm'}
                loading={loading}
                disableEscapeKeyDown={loading}
                disableBackdropClick={loading}
                className={'bound-dialog'}
                scroll={'paper'}
                aria-labelledby="scroll-dialog-title"
            >
                <DialogTitle id={'scroll-dialog-title'}>
                    <p className={`text-lg text-color-1 my-3 font-weight-bold text-center`}>
                        {
                            submissionErrors
                                ? "Bypass Submission Error"
                                : inEditMode
                                    ? "Edit Bypass Reasons"
                                    : `Bypass Order ${orderNo ?? ''}`
                        }
                    </p>
                    <Divider className='divider'/>
                </DialogTitle>
                {
                    submissionErrors
                        ? <ConfigureCustomerBypassLimitsSection
                            customer={customer}
                            submissionErrors={submissionErrors}
                            setSubmissionErrors={setSubmissionErrors}
                            setOpen={setOpen}
                        />
                        : <>
                            {
                                inEditMode &&
                                <UpsertBypassReasonsSection
                                    reasons={reasons}
                                    setReasons={setReasons}
                                    setInEditMode={setInEditMode}
                                />
                            }
                            {
                                !inEditMode &&
                                <SubmitBypassSection
                                    reasons={reasons}
                                    onBypassSuccess={onBypassSuccess}
                                    setInEditMode={setInEditMode}
                                    setSubmissionErrors={setSubmissionErrors}
                                    customer={customer}
                                    orderId={orderId}
                                />
                            }
                        </>
                }
            </Dialog>
        </>
    )
}


export default BypassOrderDialog;
